import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useParams } from "react-router-dom";
import TextTruncate from 'react-text-truncate';
import {Helmet} from "react-helmet";

import { MdKeyboardBackspace } from "react-icons/md";
import { GoFileSymlinkFile } from "react-icons/go";

import './css/Home.css'
import manSrc from '../images/man.png'
import stSrc from '../images/st3.png'
import { AppContext } from "../Context";
import Fetch, { Loader, dateToText, FixNumbers } from "../inc/Fetch";
import { Img, Tasks, Games } from "../components/Elements";

import Footer from "./Footer";
import Header from "./Header";
import Dictionary from "./popups/Dictionary";


export default function Cat() {

	const params = useParams();

	const {success, userinfo, languageText, language, showQuiz, loginForm} = useContext(AppContext);
	const [open, setopen] = success;
	const [text, settext] = languageText;
	const [lang, setlang] = language;
	const [showQuizD, setshowQuizD] = showQuiz;
	const [user, setuser] = userinfo;
	const [openLogin, setopenLogin] = loginForm;

	const [data, setdata] = useState({});
	const [loader, setloader] = useState(true);
	const [openDic, setopenDic] = useState(false);

	
	function loadData() {
		Fetch("Cat", (d) => {
			
			if (!d?.error) {
				setdata(d);
			}

			setloader(false);
		}, { classes: params?.classes, cat: params?.cat });
	}

	useEffect(() => {
		loadData();
		
	}, [params?.classes, params?.cat]);

	useEffect(() => {
		if (params?.quiz && data?.quizs?.length && user?.userinfo?._id) {
			let q = data?.quizs?.find(q => `${q?._id}` == params?.quiz);
			if (q?._id) setshowQuizD(q)
			
		}
	}, [data?.quizs])

	if (loader) {
		return (<Loader />);
	}

	let results = data?.cats?.filter(r => r?.classes == params?.classes && !r?.parent );
	
    let sectName = {};
    let sectPar = {};
    let sectPar2 = {};
    let sectPar3 = {};
    if (params?.cat) {

        results = data?.cats?.filter(r => r?.parent == params?.cat);
        sectName = data?.cats?.filter(r => `${r?._id}` == params?.cat)[0];
		
        sectPar = data?.cats?.filter(r => `${r?._id}` == sectName?.parent)[0];
        sectPar2 = data?.cats?.filter(r => `${r?._id}` == sectPar?.parent)[0];
        sectPar3 = data?.cats?.filter(r => `${r?._id}` == sectPar2?.parent)[0];
    }

	return (
		
		<>
			{openDic && <Dictionary open={openDic} setopen={setopenDic} />}

			<Helmet>

                <title>موقع العربية</title>

            </Helmet>
			<Header title={sectName?.name ? `${sectName?.name} (الصف ${global?.Classes[params?.classes]})` : `مواد محوسبة (الصف ${global?.Classes[params?.classes]})`} img={sectName?.name ? sectName?.poster : data?.classes?.img} small={true} data={data?.news} />

			<nav className='catsPathAll'>

				<div className='mainWidth'>
					<Link to={`/`}>صفحة البيت</Link>
					<MdKeyboardBackspace />
					<Link to={`/cat/${params?.classes}`}>الصف {global?.Classes[params?.classes]}</Link>

					{params?.cat && 
					<>
						{sectPar3?.name && <>
							<MdKeyboardBackspace />
							<Link to={`/cat/${params?.classes}/${sectPar3?._id}`}>{sectPar3?.name}</Link>
						</>}
						{sectPar2?.name && <>
							<MdKeyboardBackspace />
							<Link to={`/cat/${params?.classes}/${sectPar2?._id}`}>{sectPar2?.name}</Link>
						</>}
						{sectPar?.name && <>
							<MdKeyboardBackspace />
							<Link to={`/cat/${params?.classes}/${sectPar?._id}`}>{sectPar?.name}</Link>
						</>}
					</>
					}

					{sectName?.name && <>
						<MdKeyboardBackspace />
						<Link to={`/cat/${params?.classes}`}>{sectName?.name}</Link>
						
					</>}
				</div>
			</nav>
			<div className='body'>
				

				<section className='sect5' style={{padding:'10px 0 40px 0'}}>
					<div className='mainWidth'>

						

						 <div className='catsListBox'>
							{results?.map(v => {

								return (
									<div>
										<Link to={`/cat/${params?.classes}/${v?._id}`}>
											<Img src={v?.img} />
											<h4>{v?.name}</h4>
										</Link>
									</div>
								);
							})}
							
						</div>
						
						 <div className='dataListBox'>
							{data?.files?.map(v => {
								
								return (
									<div>
										<Link target='_blank' to={`/downloadFile/${v?._id}`}>
											<GoFileSymlinkFile />
											<h4>{v?.name}</h4>
										</Link>
									</div>
								);
							})}

							{data?.quizs?.map(v => { 
								
								return (
									<div>
            							<Link onClick={() => user?.userinfo?._id ? setshowQuizD(v) : setopenLogin(true)}>
											<Img src={`img/200x100${v?.img}`} />
											<h4>{v?.name}</h4>
										</Link>
									</div>
								);
							})}


						</div>
						{!results?.length && !data?.files?.length && !data?.quizs?.length ? <div className='noData'>لا توجد مواد محوسبة في هذا القسم</div> : false}
						
						
						
					</div>
				</section>

			</div>


			<Footer />
		</>
	)
}
